export default __webpack_public_path__ + "static/media/Shaka_particle_final_15.189f58e0.png";